import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vant
import Vant from 'vant';
import 'vant/lib/index.css';

// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

// Axios
import Axios from 'axios'
if (process.env.NODE_ENV == 'development') {
    Axios.defaults.baseURL = 'https://dev.cloud-api.ennea.cn'
} else {
    Axios.defaults.baseURL = 'http://cloud-api.ennea.cn'
}

const app = createApp(App)

// 自动注册组件
const requireComponents = require.context('./components', true, /\.vue/)
requireComponents.keys().forEach(fileName => {
    const componentInstance = requireComponents(fileName)
    app.component(componentInstance.default.name, componentInstance.default || componentInstance)
})

app.use(store)
app.use(router)
app.use(Vant)
app.config.globalProperties.$axios = Axios
app.mount('#app')
